import { render, staticRenderFns } from "./Registry.vue?vue&type=template&id=c4a910de&scoped=true&"
import script from "./Registry.vue?vue&type=script&lang=js&"
export * from "./Registry.vue?vue&type=script&lang=js&"
import style0 from "./Registry.vue?vue&type=style&index=0&id=c4a910de&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4a910de",
  null
  
)

export default component.exports